export default function SuccessStories() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Success Stories</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Real authors, real results, real engagement
          </p>
        </div>
        
        <div className="mb-20">
          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-12 shadow-xl border-l-4 border-amber-500 max-w-5xl mx-auto">
            <div className="flex items-start gap-4 mb-6">
              <i className="ri-double-quotes-l text-6xl text-amber-500"></i>
            </div>
            <p className="text-2xl text-gray-700 leading-relaxed mb-8 italic">
              Working with APEX transformed my book's reach. The book clubs were genuinely engaged, and the discussions were thoughtful and enthusiastic. The reviews came quickly, and the visibility boost was exactly what I needed.
            </p>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/18c9072bd71adb24a96e04ea147e8334/c1b6b31be3e451b42b09c45a371e341e.jpeg" 
                  alt="Dawn Steinman"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <div className="font-bold text-gray-900 text-lg">Dawn Steinman</div>
                <div className="text-gray-600">Author of "THE GHOST SHIPS: JOURNEY INTO THE VOID"</div>
              </div>
            </div>
            <div className="flex gap-2 mb-8">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-3xl text-amber-500"></i>
              ))}
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 pt-8 border-t-2 border-amber-200">
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-book-open-line text-2xl text-amber-600"></i>
                  The Book Club Experience
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  Dawn's science fiction novel was introduced to 15 carefully selected book clubs specializing in sci-fi and speculative fiction. Each club received advance copies and engaged in deep discussions about the themes, characters, and world-building.
                </p>
              </div>
              
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-chat-3-line text-2xl text-amber-600"></i>
                  Authentic Engagement
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  The book clubs didn't just read—they discussed plot twists, debated character motivations, and shared their genuine reactions. This led to thoughtful, detailed reviews that helped other readers discover the book.
                </p>
              </div>
              
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-line-chart-line text-2xl text-amber-600"></i>
                  Measurable Results
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  Within three weeks, Dawn saw a significant increase in Amazon reviews, improved visibility in sci-fi categories, and a noticeable uptick in organic sales. The book's rating stabilized at 4.5+ stars with authentic reader feedback.
                </p>
              </div>
              
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-heart-line text-2xl text-amber-600"></i>
                  Long-Term Impact
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  Beyond the immediate campaign, Dawn gained a dedicated reader base. Several book club members became fans who eagerly await her next release, and word-of-mouth recommendations continue to drive new readers to her work.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border-t-4 border-amber-500">
            <div className="text-5xl font-bold text-amber-500 mb-4">87%</div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Review Rate</h4>
            <p className="text-gray-700 leading-relaxed">
              Of book club members leave thoughtful reviews after reading promoted titles
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border-t-4 border-amber-500">
            <div className="text-5xl font-bold text-amber-500 mb-4">2-3x</div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Visibility Boost</h4>
            <p className="text-gray-700 leading-relaxed">
              Average increase in book visibility and reader engagement after APEX campaigns
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border-t-4 border-amber-500">
            <div className="text-5xl font-bold text-amber-500 mb-4">14</div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Days Average</h4>
            <p className="text-gray-700 leading-relaxed">
              Fast turnaround time for reviews and meaningful discussions to begin
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
